export const defaultTestCaseFilters = {
  priority: "All",
  status: "All",
  module: [],
  owner: [],
  technologyLayer: "All",
  geographies: [],
  languages: [],
  cloudDevice: [],
  platforms: [],
  subPlatforms: [],
};

